import type { Dict } from "../core.js";
import type { sources as vi } from "../vi/sources.js";

export const sources: Dict<typeof vi> = {
  title: "Data sources",
  subtitle: "The hub reads each app's database read-only. « Not configured » is not an incident.",
  loadListFailed: "Couldn't load the source list.",
  deduplicated: "A scan is already running — following that one.",
  queued: "Queued.",
  serverUnreachable: "Couldn't reach the server.",
  viewRun: "View run",
  emptyTitle: "No sources yet.",
  emptyBefore: "The worker adds its sources on startup. See ",
  emptyAfter: " §3 to grant read-only access to each database.",
  lastRun: "Last scanned {time}",
  neverRun: "Never scanned",
  driftColumns: "Drifted columns:",
  unsupportedCount: "{count} unsupported areas",
  queueing: "Queueing…",
  refreshNow: "Refresh now",

  loadDetailFailed: "Couldn't load source details.",
  detailMeta: "{kind} · {status} · adapter {adapter} · contract {contract}",
  dsnBefore: "Connection string is read from ",
  dsnAfter: " — only the worker process holds it.",
  driftTitle: "Schema drift — the hub has STOPPED ingesting this stream.",
  driftBefore: "The cursor ",
  driftStrong: "does not advance",
  driftAfter: ", so once the connector is fixed, the next run catches up on the missed window.",
  streams: "Streams",
  "col.stream": "Stream",
  "col.capability": "Capability",
  "col.fingerprint": "Fingerprint",
  "col.watermark": "Read up to",
  "col.lastSuccess": "Last success",
  "col.safetyWindow": "Safety window",
  notChecked: "not checked",
  metricBases: "Metric basis",
  unsupportedTitle: "What this source can't measure",
  recentRuns: "Last 20 runs",
  "col.result": "Result",
  "col.rows": "Rows",
  "col.requested": "Queued",
  "col.finished": "Finished",
  noRuns: "No runs yet.",
};
